// AllProducts.jsx
import { useLocation } from "react-router-dom";
import { useEffect, useState, useCallback, 
  // useRef
 } from "react";
import axios from "axios";
import { FaCheckCircle } from "react-icons/fa";
import ProductCard from "../../components/ProductCard";
import { 
  Container, 
  Typography, 
 
  // InputLabel, 
  
  IconButton,
 
  Chip,
  
  Divider,
  Button,
  Checkbox,
  FormGroup,
  FormControlLabel,
  
  Pagination,
  PaginationItem,
  
  CircularProgress
} from "@mui/material";
import { 
 
  Tune,
  ClearAll,
  ArrowDropDown,
  ArrowForward,
  ArrowBack,
  
  // Star
} from "@mui/icons-material";
import "./allProducts.scss";

const API = process.env.REACT_APP_BACKEND_URL;

// Static fallback data
const STATIC_PRODUCTS = [
  {
    _id: "1",
    name: "Classic White T-Shirt",
    price: 999,
    originalPrice: 1499,
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500",
    category: "T-Shirts",
    gender: "men",
    color: "White",
    size: ["S", "M", "L", "XL"],
    rating: 4.5,
    reviewCount: 128,
    discount: 33,
    brand: "Fashion Hub",
    inStock: true
  },
  {
    _id: "2",
    name: "Slim Fit Jeans",
    price: 1999,
    originalPrice: 2999,
    image: "https://images.unsplash.com/photo-1541099649105-f69ad21f3246?w=500",
    category: "Jeans",
    gender: "men",
    color: "Blue",
    size: ["28", "30", "32", "34"],
    rating: 4.2,
    reviewCount: 89,
    discount: 33,
    brand: "Denim Co",
    inStock: true
  },
  {
    _id: "3",
    name: "Floral Summer Dress",
    price: 2499,
    originalPrice: 3999,
    image: "https://images.unsplash.com/photo-1572804013309-59a88b7e92f1?w=500",
    category: "Dresses",
    gender: "women",
    color: "Pink",
    size: ["XS", "S", "M", "L"],
    rating: 4.8,
    reviewCount: 256,
    discount: 38,
    brand: "Summer Vibes",
    inStock: true
  },
  {
    _id: "4",
    name: "Leather Jacket",
    price: 4999,
    originalPrice: 7999,
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=500",
    category: "Jackets",
    gender: "men",
    color: "Black",
    size: ["M", "L", "XL"],
    rating: 4.6,
    reviewCount: 67,
    discount: 38,
    brand: "Urban Style",
    inStock: true
  },
  {
    _id: "5",
    name: "Running Shoes",
    price: 2999,
    originalPrice: 4499,
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=500",
    category: "Footwear",
    gender: "men",
    color: "Red",
    size: ["7", "8", "9", "10"],
    rating: 4.4,
    reviewCount: 192,
    discount: 33,
    brand: "SportsPro",
    inStock: true
  },
  {
    _id: "6",
    name: "Handbag",
    price: 3499,
    originalPrice: 4999,
    image: "https://images.unsplash.com/photo-1584917865448-2e3f7c1c3a8d?w=500",
    category: "Accessories",
    gender: "women",
    color: "Brown",
    size: ["One Size"],
    rating: 4.7,
    reviewCount: 145,
    discount: 30,
    brand: "Luxury Lane",
    inStock: true
  },
  {
    _id: "7",
    name: "Casual Sneakers",
    price: 1999,
    originalPrice: 2999,
    image: "https://images.unsplash.com/photo-1525966222134-fcfa99b8ae77?w=500",
    category: "Footwear",
    gender: "women",
    color: "White",
    size: ["5", "6", "7", "8"],
    rating: 4.3,
    reviewCount: 178,
    discount: 33,
    brand: "ComfortStep",
    inStock: true
  },
  {
    _id: "8",
    name: "Formal Shirt",
    price: 1499,
    originalPrice: 2499,
    image: "https://images.unsplash.com/photo-1598033121395-5c6d5f5b7b8d?w=500",
    category: "Shirts",
    gender: "men",
    color: "Blue",
    size: ["S", "M", "L", "XL"],
    rating: 4.1,
    reviewCount: 95,
    discount: 40,
    brand: "Corporate",
    inStock: true
  },
  {
    _id: "9",
    name: "Summer Shorts",
    price: 899,
    originalPrice: 1499,
    image: "https://images.unsplash.com/photo-1591195853828-11db59a44f6f?w=500",
    category: "Shorts",
    gender: "men",
    color: "Khaki",
    size: ["S", "M", "L", "XL"],
    rating: 4.0,
    reviewCount: 67,
    discount: 40,
    brand: "BeachLife",
    inStock: true
  },
  {
    _id: "10",
    name: "Kurti",
    price: 1299,
    originalPrice: 1999,
    image: "https://images.unsplash.com/photo-1618354691373-d851c5c3a990?w=500",
    category: "Ethnic",
    gender: "women",
    color: "Green",
    size: ["S", "M", "L"],
    rating: 4.5,
    reviewCount: 156,
    discount: 35,
    brand: "EthnicWear",
    inStock: true
  },
  {
    _id: "11",
    name: "Wrist Watch",
    price: 2999,
    originalPrice: 4999,
    image: "https://images.unsplash.com/photo-1524592094714-0f0654e20314?w=500",
    category: "Accessories",
    gender: "men",
    color: "Silver",
    size: ["One Size"],
    rating: 4.6,
    reviewCount: 234,
    discount: 40,
    brand: "TimePiece",
    inStock: true
  },
  {
    _id: "12",
    name: "Sunglasses",
    price: 1499,
    originalPrice: 2499,
    image: "https://images.unsplash.com/photo-1511499767150-a48a237f3083?w=500",
    category: "Accessories",
    gender: "women",
    color: "Black",
    size: ["One Size"],
    rating: 4.3,
    reviewCount: 89,
    discount: 40,
    brand: "VisionPlus",
    inStock: true
  },
  {
    _id: "13",
    name: "Hoodie",
    price: 1999,
    originalPrice: 2999,
    image: "https://images.unsplash.com/photo-1556905055-8f358a7a47b2?w=500",
    category: "Sweatshirts",
    gender: "men",
    color: "Gray",
    size: ["S", "M", "L", "XL"],
    rating: 4.4,
    reviewCount: 123,
    discount: 33,
    brand: "StreetWear",
    inStock: true
  },
  {
    _id: "14",
    name: "Yoga Pants",
    price: 1599,
    originalPrice: 2499,
    image: "https://images.unsplash.com/photo-1506624183912-c1a5f8f3c1c9?w=500",
    category: "Activewear",
    gender: "women",
    color: "Black",
    size: ["XS", "S", "M", "L"],
    rating: 4.7,
    reviewCount: 201,
    discount: 36,
    brand: "FlexFit",
    inStock: true
  },
  {
    _id: "15",
    name: "Backpack",
    price: 2199,
    originalPrice: 3499,
    image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=500",
    category: "Bags",
    gender: "unisex",
    color: "Navy",
    size: ["One Size"],
    rating: 4.5,
    reviewCount: 167,
    discount: 37,
    brand: "TravelMate",
    inStock: true
  },
  {
    _id: "16",
    name: "Formal Trousers",
    price: 1799,
    originalPrice: 2799,
    image: "https://images.unsplash.com/photo-1473966968600-fa6a4f9c6b8a?w=500",
    category: "Trousers",
    gender: "men",
    color: "Black",
    size: ["28", "30", "32", "34", "36"],
    rating: 4.2,
    reviewCount: 78,
    discount: 36,
    brand: "FormalEdge",
    inStock: true
  },
  {
    _id: "17",
    name: "Silk Saree",
    price: 3999,
    originalPrice: 5999,
    image: "https://images.unsplash.com/photo-1583391733956-6c7827647d9e?w=500",
    category: "Ethnic",
    gender: "women",
    color: "Red",
    size: ["One Size"],
    rating: 4.9,
    reviewCount: 345,
    discount: 33,
    brand: "Heritage",
    inStock: true
  },
  {
    _id: "18",
    name: "Sports Bra",
    price: 899,
    originalPrice: 1499,
    image: "https://images.unsplash.com/photo-1591217789708-3e6b8c7a2b3a?w=500",
    category: "Activewear",
    gender: "women",
    color: "Pink",
    size: ["S", "M", "L"],
    rating: 4.3,
    reviewCount: 92,
    discount: 40,
    brand: "ActiveGear",
    inStock: true
  },
  {
    _id: "19",
    name: "Cargo Pants",
    price: 2199,
    originalPrice: 3299,
    image: "https://images.unsplash.com/photo-1624378439575-d8705ad7ae80?w=500",
    category: "Trousers",
    gender: "men",
    color: "Olive",
    size: ["30", "32", "34", "36"],
    rating: 4.1,
    reviewCount: 67,
    discount: 33,
    brand: "UrbanWear",
    inStock: true
  },
  {
    _id: "20",
    name: "Belt",
    price: 599,
    originalPrice: 999,
    image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=500",
    category: "Accessories",
    gender: "men",
    color: "Brown",
    size: ["S", "M", "L"],
    rating: 4.0,
    reviewCount: 45,
    discount: 40,
    brand: "LeatherCraft",
    inStock: true
  },
  {
    _id: "21",
    name: "Scarf",
    price: 499,
    originalPrice: 899,
    image: "https://images.unsplash.com/photo-1601924994987-69e26d50dc26?w=500",
    category: "Accessories",
    gender: "women",
    color: "Multicolor",
    size: ["One Size"],
    rating: 4.2,
    reviewCount: 56,
    discount: 44,
    brand: "StyleStudio",
    inStock: true
  },
  {
    _id: "22",
    name: "Blazer",
    price: 4499,
    originalPrice: 6999,
    image: "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=500",
    category: "Formal",
    gender: "men",
    color: "Navy",
    size: ["S", "M", "L", "XL"],
    rating: 4.5,
    reviewCount: 89,
    discount: 36,
    brand: "Executive",
    inStock: true
  },
  {
    _id: "23",
    name: "Jumpsuit",
    price: 2799,
    originalPrice: 3999,
    image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=500",
    category: "Dresses",
    gender: "women",
    color: "Black",
    size: ["S", "M", "L"],
    rating: 4.4,
    reviewCount: 134,
    discount: 30,
    brand: "Trendy",
    inStock: true
  },
  {
    _id: "24",
    name: "Cap",
    price: 399,
    originalPrice: 799,
    image: "https://images.unsplash.com/photo-1521369909029-2a6c3e1d6c2d?w=500",
    category: "Accessories",
    gender: "unisex",
    color: "Black",
    size: ["One Size"],
    rating: 4.1,
    reviewCount: 234,
    discount: 50,
    brand: "StreetStyle",
    inStock: true
  }
];

const AllProducts = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [displayProducts, setDisplayProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initialLoading, setInitialLoading] = useState(true);
  // const [loadingMore, setLoadingMore] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("default");
  const [priceRange, setPriceRange] = useState([0, 10000]);
  const [categories, setCategories] = useState([]);
  // const [selectedCategory, setSelectedCategory] = useState("all");
  // const [mobileFilterOpen, setMobileFilterOpen] = useState(false);
  // eslint-disable-next-line
  const [viewMode, setViewMode] = useState("grid");
  const [activeFilters, setActiveFilters] = useState([]);
  
  // New filter states
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedColors, setSelectedColors] = useState([]);
  const [selectedSizes, setSelectedSizes] = useState([]);
  const [selectedRatings, setSelectedRatings] = useState(0);
  const [selectedDiscount, setSelectedDiscount] = useState(0);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line
  const [itemsPerPage] = useState(12);
  const [totalPages, setTotalPages] = useState(1);
  
  // const observerRef = useRef();
  // const loaderRef = useRef();

// const navigate = useNavigate();

 const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialCategory = queryParams.get("category") || "all";

  const [selectedCategory, setSelectedCategory] = useState(initialCategory);



// const handleCategorySelect = (cat) => {
//   setSelectedCategory(cat);         
//   navigate(`/products?category=${cat}`); 
// };




    const normalizedProducts = products.map(p => ({
    ...p,
    image: p.mainImage || p.image || "",
    size: p.sizes || p.size || [],
    color: Array.isArray(p.color) ? p.color : (p.color ? [p.color] : []),
    gender: p.gender || "",
    discount: Number(p.discount) || 0,
    originalPrice: Number(p.originalPrice) || 0,
    rating: p.rating || 0
  }));
  // Get unique values for filters
  const defaultGenders = ["men", "women", "kids"];
const genders = [
  ...new Set([
    ...defaultGenders,
    ...normalizedProducts
      .map(p => p.gender?.toLowerCase())
      .filter(Boolean)
  ])
];
//  const colors = [
//     ...new Set(
//       products.flatMap(p => 
//         Array.isArray(p.color) ? p.color : [p.color]
//       )
//     )
//   ].filter(Boolean);
  // const sizes = [
  //   ...new Set(
  //     normalizedProducts.flatMap(p => p.size || [])
  //   )
  // ];
  // const discountRanges = [10, 20, 30, 40, 50];

  useEffect(() => {
    fetchProducts();
  }, []);


useEffect(() => {
  const queryParams = new URLSearchParams(location.search);
  const categoryFromURL = queryParams.get("category") || "all";

  // Only update if different to avoid infinite loop
  if (categoryFromURL !== selectedCategory) {
    setSelectedCategory(categoryFromURL);
  }
  // eslint-disable-next-line
}, [location.search]); 
  // Update active filters
  useEffect(() => {
    const filters = [];
    if (searchTerm) filters.push({ type: 'search', value: searchTerm });
    if (selectedCategory !== 'all') filters.push({ type: 'category', value: selectedCategory });
    if (priceRange[0] > 0 || priceRange[1] < 10000) {
      filters.push({ type: 'price', value: `₹${priceRange[0]} - ₹${priceRange[1]}` });
    }
    if (selectedGenders.length > 0) {
      filters.push({ type: 'gender', value: selectedGenders.join(', ') });
    }
    if (selectedColors.length > 0) {
      filters.push({ type: 'color', value: selectedColors.join(', ') });
    }
    if (selectedSizes.length > 0) {
      filters.push({ type: 'size', value: selectedSizes.join(', ') });
    }
    if (selectedRatings > 0) {
      filters.push({ type: 'rating', value: `${selectedRatings}+ Stars` });
    }
    if (selectedDiscount > 0) {
      filters.push({ type: 'discount', value: `${selectedDiscount}% or more` });
    }
    if (sortBy !== 'default') {
      const sortLabels = {
        'price-low': 'Price: Low to High',
        'price-high': 'Price: High to Low',
        'name-asc': 'Name: A to Z',
        'name-desc': 'Name: Z to A',
        'rating': 'Top Rated',
        'discount': 'Biggest Discount'
      };
      filters.push({ type: 'sort', value: sortLabels[sortBy] });
    }
    setActiveFilters(filters);
  }, [searchTerm, selectedCategory, priceRange, selectedGenders, selectedColors, selectedSizes, selectedRatings, selectedDiscount, sortBy]);

  const filterAndSortProducts = useCallback(() => {
   
      const normalizedProducts = products.map(p => ({
          ...p,
          image: p.mainImage || p.image || "",
          size: p.sizes || p.size || [],
          color: Array.isArray(p.color) ? p.color : (p.color ? [p.color] : []),
          gender: p.gender || "",
          discount: Number(p.discount) || 0,
          originalPrice: Number(p.originalPrice) || 0,
          rating: p.rating || 0
        }));
    let filtered = [...normalizedProducts];

    // Search filter
    if (searchTerm) {
      filtered = filtered.filter(p => 
        p.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.brand?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Category filter
    if (selectedCategory !== "all") {
      filtered = filtered.filter(p => p.category === selectedCategory);
    }

    // Gender filter
    if (selectedGenders.length > 0) {
      filtered = filtered.filter(p =>
        selectedGenders.includes(p.gender?.toLowerCase())
      );
    }

    // Color filter
    if (selectedColors.length > 0) {
      filtered = filtered.filter(p =>
        p.color?.some(c => selectedColors.includes(c))
      );
    }

    // Size filter
    if (selectedSizes.length > 0) {
      filtered = filtered.filter(p =>
        p.size?.some(s => selectedSizes.includes(s))
      );
    }

    // Rating filter
    if (selectedRatings > 0) {
      filtered = filtered.filter(p => (p.rating || 0) >= selectedRatings);
    }

    // Discount filter
    if (selectedDiscount > 0) {
      filtered = filtered.filter(p => (Number(p.discount) || 0) >= selectedDiscount);
    }

    // Price filter
    filtered = filtered.filter(p => 
      p.price >= priceRange[0] && p.price <= priceRange[1]
    );

    // Sorting
    switch(sortBy) {
      case "price-low":
        filtered.sort((a, b) => a.price - b.price);
        break;
      case "price-high":
        filtered.sort((a, b) => b.price - a.price);
        break;
      case "name-asc":
        filtered.sort((a, b) => a.name?.localeCompare(b.name));
        break;
      case "name-desc":
        filtered.sort((a, b) => b.name?.localeCompare(a.name));
        break;
      case "rating":
        filtered.sort((a, b) => b.rating - a.rating);
        break;
      case "discount":
        filtered.sort((a, b) => b.discount - a.discount);
        break;
      default:
        break;
    }

    setFilteredProducts(filtered);
    setTotalPages(Math.ceil(filtered.length / itemsPerPage));
    setCurrentPage(1);
    // eslint-disable-next-line
  }, [products, searchTerm, sortBy, priceRange, selectedCategory, selectedGenders, selectedColors, selectedSizes, selectedRatings, selectedDiscount]);

  useEffect(() => {
    filterAndSortProducts();
  }, [filterAndSortProducts]);

  // Update displayed products based on pagination
  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setDisplayProducts(filteredProducts.slice(startIndex, endIndex));
    // eslint-disable-next-line
  }, [filteredProducts, currentPage, itemsPerPage]);

const fetchProducts = async () => {
  try {
    setInitialLoading(true);

    let finalProducts = [];

    try {
      const res = await axios.get(`${API}/api/products`);

      if (res.data && res.data.length > 0) {
        finalProducts = res.data;   // ✅ Priority to API
      } else {
        finalProducts = STATIC_PRODUCTS; // fallback
      }
    } catch (err) {
      console.log("Using static data");
      finalProducts = STATIC_PRODUCTS;
    }

    setProducts(finalProducts);

    // categories
    const uniqueCategories = [
      ...new Set(finalProducts.map(p => p.category).filter(Boolean))
    ];
    setCategories(uniqueCategories);

    // max price
    const maxPrice = Math.max(...finalProducts.map(p => p.price || 0));
    setPriceRange([0, maxPrice]);

  } catch (err) {
    console.log(err);
  } finally {
    setInitialLoading(false);
    setLoading(false);
  }
};

  // const handlePriceChange = (event, newValue) => {
  //   setPriceRange(newValue);
  // };

  const clearFilters = () => {
    setSearchTerm("");
    setSortBy("default");
    setPriceRange([0, Math.max(...products.map(p => p.price))]);
    setSelectedCategory("all");
    setSelectedGenders([]);
    setSelectedColors([]);
    setSelectedSizes([]);
    setSelectedRatings(0);
    setSelectedDiscount(0);
  };

  // const removeFilter = (filterType) => {
  //   switch(filterType) {
  //     case 'search':
  //       setSearchTerm("");
  //       break;
  //     case 'category':
  //       setSelectedCategory("all");
  //       break;
  //     case 'price':
  //       setPriceRange([0, Math.max(...products.map(p => p.price))]);
  //       break;
  //     case 'gender':
  //       setSelectedGenders([]);
  //       break;
  //     case 'color':
  //       setSelectedColors([]);
  //       break;
  //     case 'size':
  //       setSelectedSizes([]);
  //       break;
  //     case 'rating':
  //       setSelectedRatings(0);
  //       break;
  //     case 'discount':
  //       setSelectedDiscount(0);
  //       break;
  //     case 'sort':
  //       setSortBy("default");
  //       break;
  //     default:
  //       break;
  //   }
  // };

  const handleGenderChange = (gender) => {
    setSelectedGenders(prev =>
      prev.includes(gender) ? prev.filter(g => g !== gender) : [...prev, gender]
    );
  };

  // const handleColorChange = (color) => {
  //   setSelectedColors(prev =>
  //     prev.includes(color) ? prev.filter(c => c !== color) : [...prev, color]
  //   );
  // };

  // const handleSizeChange = (size) => {
  //   setSelectedSizes(prev =>
  //     prev.includes(size) ? prev.filter(s => s !== size) : [...prev, size]
  //   );
  // };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const FilterContent = () => (
    <div className="filter-content">
      <div className="filter-header">
        <div className="filter-header-title">
          <Tune className="filter-icon" />
          <Typography variant="h6">Filters</Typography>
        </div>
        {activeFilters.length > 0 && (
          <IconButton onClick={clearFilters} className="clear-all-btn" size="small">
            <ClearAll />
          </IconButton>
        )}
      </div>

      <Divider className="filter-divider" />

     {/* Categories */}
<div className="filter-section">
  <div className="filter-section-header">
    <Typography variant="subtitle1" className="filter-title">
      Categories
    </Typography>
    <ArrowDropDown className="section-arrow" />
  </div>
  <div className="category-list">
    {/* All Categories Chip */}
    <Chip
      label="All Categories"
      onClick={() => setSelectedCategory("all")}
      clickable
      size="small"
      variant={selectedCategory === "all" ? "filled" : "outlined"}
      color={selectedCategory === "all" ? "primary" : "default"}
      icon={selectedCategory === "all" ? <FaCheckCircle /> : null}
    />

    {/* Map over categories */}
    {categories?.map((cat) => (
      <Chip
        key={cat}
        label={cat}
        onClick={() => setSelectedCategory(cat)}
        clickable
        size="small"
        variant={selectedCategory === cat ? "filled" : "outlined"}
        color={selectedCategory === cat ? "primary" : "default"}
        icon={selectedCategory === cat ? <FaCheckCircle /> : null}
      />
    ))}
  </div>
</div>

      <Divider className="filter-divider" />

      {/* Gender */}
      <div className="filter-section">
        <div className="filter-section-header">
          <Typography variant="subtitle1" className="filter-title">
            Gender
          </Typography>
        </div>
        <FormGroup>
          {genders.map(gender => (
            <FormControlLabel
              key={gender}
              control={
                <Checkbox
                  checked={selectedGenders.includes(gender)}
                  onChange={() => handleGenderChange(gender)}
                  size="small"
                  sx={{
                    color: '#614d42',
                    '&.Mui-checked': { color: '#614d42' },
                  }}
                />
              }
              label={gender.charAt(0).toUpperCase() + gender.slice(1)}
            />
          ))}
        </FormGroup>
      </div>

      <Divider className="filter-divider" />

      {/* Price Range */}
      {/* <div className="filter-section">
        <div className="filter-section-header">
          <Typography variant="subtitle1" className="filter-title">
            Price Range
          </Typography>
        </div>
        <Slider
          value={priceRange}
          onChange={handlePriceChange}
          valueLabelDisplay="auto"
          min={0}
          max={Math.max(...products.map(p => p.price))}
          className="price-slider"
        />
        <div className="price-inputs">
          <TextField
            size="small"
            value={priceRange[0]}
            onChange={(e) => setPriceRange([Number(e.target.value), priceRange[1]])}
            InputProps={{ startAdornment: '₹' }}
            className="price-input"
          />
          <span className="price-separator">-</span>
          <TextField
            size="small"
            value={priceRange[1]}
            onChange={(e) => setPriceRange([priceRange[0], Number(e.target.value)])}
            InputProps={{ startAdornment: '₹' }}
            className="price-input"
          />
        </div>
      </div> */}

      {/* <Divider className="filter-divider" /> */}

      {/* Colors */}
      {/* <div className="filter-section">
        <div className="filter-section-header">
          <Typography variant="subtitle1" className="filter-title">
            Colors
          </Typography>
        </div>
        <div className="color-filter-list">
          {colors.map(color => (
            <Chip
              key={color}
              label={color}
              onClick={() => handleColorChange(color)}
              className={`color-filter-chip ${selectedColors.includes(color) ? 'active' : ''}`}
              size="small"
            />
          ))}
        </div>
      </div> */}

      {/* <Divider className="filter-divider" /> */}

      {/* Sizes */}
      {/* <div className="filter-section">
        <div className="filter-section-header">
          <Typography variant="subtitle1" className="filter-title">
            Sizes
          </Typography>
        </div>
        <div className="size-filter-list">
          {sizes.map(size => (
            <Chip
              key={size}
              label={size}
              onClick={() => handleSizeChange(size)}
              className={`size-filter-chip ${selectedSizes.includes(size) ? 'active' : ''}`}
              size="small"
            />
          ))}
        </div>
      </div> */}

      {/* <Divider className="filter-divider" /> */}

      {/* Ratings */}
      {/* <div className="filter-section">
        <div className="filter-section-header">
          <Typography variant="subtitle1" className="filter-title">
            Minimum Rating
          </Typography>
        </div>
        <Box sx={{ width: '100%' }}>
          <Rating
            value={selectedRatings}
            onChange={(event, newValue) => setSelectedRatings(newValue)}
            precision={0.5}
            size="medium"
            sx={{
              '& .MuiRating-iconFilled': {
                color: '#614d42',
              },
            }}
          />
        </Box>
      </div> */}

      {/* <Divider className="filter-divider" /> */}

      {/* Discount */}
      {/* <div className="filter-section">
        <div className="filter-section-header">
          <Typography variant="subtitle1" className="filter-title">
            Discount
          </Typography>
        </div>
        <div className="discount-filter-list">
          {discountRanges.map(discount => (
            <Chip
              key={discount}
              label={`${discount}% or more`}
              onClick={() => setSelectedDiscount(discount)}
              className={`discount-chip ${selectedDiscount === discount ? 'active' : ''}`}
              size="small"
            />
          ))}
        </div>
      </div> */}
    </div>
  );

  if (initialLoading) {
    return (
      <div className="initial-loader">
        <CircularProgress sx={{ color: '#614d42' }} />
        <Typography variant="body1">Loading amazing products...</Typography>
      </div>
    );
  }

  return (
    <div className="all-products-page" style={{ marginTop: "80px" }}>
      {/* Header Banner */}
      {/* <div className="page-header">
        <Container maxWidth="xl">
          <Typography variant="h4" className="page-title">
            Our Collection
          </Typography>
          <Typography variant="body1" className="page-subtitle">
            Handpicked premium products for you
          </Typography>
          <div className="breadcrumb">
            <span>Home</span>
            <ArrowForward className="breadcrumb-icon" />
            <span className="current">All Products</span>
          </div>
        </Container>
      </div> */}

      <Container maxWidth="xl" className="main-container">
        {/* Search and Filter Bar */}
        {/* <Paper elevation={0} className="filter-bar">
          <div className="search-section">
            <Search className="search-icon" />
            <TextField
              placeholder="Search products..."
              variant="standard"
              fullWidth
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
              InputProps={{ disableUnderline: true }}
            />
          </div>

          <div className="filter-actions">
            <FormControl size="small" className="sort-select">
              <Select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                displayEmpty
                className="sort-dropdown"
              >
                <MenuItem value="default">Sort by: Featured</MenuItem>
                <MenuItem value="price-low">Price: Low to High</MenuItem>
                <MenuItem value="price-high">Price: High to Low</MenuItem>
                <MenuItem value="name-asc">Name: A to Z</MenuItem>
                <MenuItem value="name-desc">Name: Z to A</MenuItem>
                <MenuItem value="rating">Top Rated</MenuItem>
                <MenuItem value="discount">Biggest Discount</MenuItem>
              </Select>
            </FormControl>

            <IconButton 
              className="filter-toggle-btn"
              onClick={() => setMobileFilterOpen(true)}
            >
              <FilterList />
              <Badge badgeContent={activeFilters.length} color="primary" className="filter-badge" />
            </IconButton>

            <div className="view-toggle">
              <IconButton 
                className={`view-btn ${viewMode === "grid" ? "active" : ""}`}
                onClick={() => setViewMode("grid")}
              >
                <GridView />
              </IconButton>
              <IconButton 
                className={`view-btn ${viewMode === "list" ? "active" : ""}`}
                onClick={() => setViewMode("list")}
              >
                <ViewList />
              </IconButton>
            </div>
          </div>
        </Paper> */}

        {/* Active Filters */}
        {/* {activeFilters.length > 0 && (
          <div className="active-filters">
            <Typography variant="body2" className="filters-label">
              Active filters:
            </Typography>
            {activeFilters.map((filter, index) => (
              <Chip
                key={index}
                label={filter.value}
                onDelete={() => removeFilter(filter.type)}
                size="small"
                className="active-filter-chip"
              />
            ))}
            <Button 
              size="small" 
              className="clear-all-link"
              onClick={clearFilters}
            >
              Clear all
            </Button>
          </div>
        )} */}

        {/* Main Content */}
        <div className="content-wrapper">
          {/* Desktop Sidebar */}
          <aside className="desktop-sidebar">
            <FilterContent />
          </aside>

          {/* Products Section */}
          <div className="products-section">
            <div className="products-header">
              <Typography variant="body2" className="products-count">
                Showing {displayProducts.length} of {filteredProducts.length} products
              </Typography>
            </div>

            {loading ? (
              <div className="loading-state">
                {[...Array(8)].map((_, i) => (
                  <div key={i} className="skeleton-card">
                    <div className="skeleton-image" />
                    <div className="skeleton-content">
                      <div className="skeleton-line" />
                      <div className="skeleton-line short" />
                    </div>
                  </div>
                ))}
              </div>
            ) : filteredProducts.length > 0 ? (
              <>
           
                <div className={`products-grid ${viewMode}`}>
               

                  {displayProducts.map((item) => (
                    <ProductCard key={item._id} product={item} />
                  ))}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="pagination-container">
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={handlePageChange}
                      color="primary"
                      size="large"
                      
                      renderItem={(item) => (
                        <PaginationItem
                          slots={{ previous: ArrowBack, next: ArrowForward }}
                          {...item}
                          sx={{
                            '&.Mui-selected': {
                              backgroundColor: '#614d42',
                              color: 'white',
                              '&:hover': {
                                backgroundColor: '#3a2f28',
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                )}
              </>
            ) : (
              <div className="empty-state" style={{ textAlign: 'center', padding: '2rem' }}>
  <div className="empty-state-icon" style={{ fontSize: '3rem', marginBottom: '1rem' }}>✨</div>
  <Typography variant="h6" style={{ fontWeight: '600', marginBottom: '0.5rem' }}>
    Exciting New Arrivals Coming Soon!
  </Typography>
  <Typography variant="body2" color="textSecondary" style={{ marginBottom: '1.5rem', maxWidth: '300px', margin: '0 auto' }}>
    We're preparing a fresh collection for Kids, Unisex, and Women. Stay tuned – something special is on its way!
  </Typography>
  <Button 
    variant="outlined" 
    className="reset-btn"
    onClick={clearFilters}
    style={{ padding: '0.5rem 1.5rem', fontWeight: '500' }}
  >
    Clear Filters
  </Button>
</div>
            )}
          </div>
        </div>
      </Container>

      {/* Mobile Filter Drawer */}
      {/* <Drawer
        anchor="left"
        open={mobileFilterOpen}
        onClose={() => setMobileFilterOpen(false)}
        className="mobile-filter-drawer"
        PaperProps={{ className: "mobile-filter-paper" }}
      >
        <div className="mobile-filter-header">
          <Typography variant="h6">Filters</Typography>
          <IconButton onClick={() => setMobileFilterOpen(false)}>
            <Close />
          </IconButton>
        </div>
        <div className="mobile-filter-scroll">
          <FilterContent />
        </div>
        <div className="mobile-filter-footer">
          <Button 
            fullWidth 
            variant="contained" 
            className="apply-btn"
            onClick={() => setMobileFilterOpen(false)}
          >
            Apply Filters
          </Button>
        </div>
      </Drawer> */}

      {/* Scroll to Top Button */}
      {/* {currentPage > 1 && (
        <IconButton 
          className="scroll-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <ArrowUpward />
        </IconButton>
      )} */}
    </div>
  );
};

export default AllProducts;